module.exports = __webpack_public_path__ + "img/default-spades.19acfc10.svg";